import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FaVideoSlash } from "react-icons/fa";
import { API_BASE_URL } from "../../utils/constants";
import PageCenter, { NAVY } from "./PageCenter";

async function fetchHearingVideoLink(linkId) {
  const res = await fetch(`${API_BASE_URL}/api/hearing-link/${encodeURIComponent(linkId)}`);
  const body = await res.json();
  if (!res.ok || !body.videoLink) throw new Error(body.message || "Link not found or expired");
  return body.videoLink;
}

export default function HearingLinkRedirect() {
  const { linkId } = useParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!linkId) return;
    fetchHearingVideoLink(linkId)
      .then((videoLink) => window.location.replace(videoLink))
      .catch((e) => setError(e.message));
  }, [linkId]);

  if (error) {
    return (
      <PageCenter>
        <div style={{ textAlign: "center" }}>
          <FaVideoSlash size={48} color={NAVY} style={{ opacity: 0.25, marginBottom: "1rem" }} />
          <h5 style={{ color: "#dc3545", fontWeight: 700 }}>{error}</h5>
          <p style={{ color: "#888" }}>Please contact Resolution Experts for assistance.</p>
        </div>
      </PageCenter>
    );
  }

  return (
    <PageCenter>
      <div style={{ textAlign: "center" }}>
        <div className="spinner-border" style={{ width: "2.5rem", height: "2.5rem", color: NAVY }} />
        <p style={{ marginTop: "1rem", color: "#555", fontWeight: 500 }}>Redirecting to your hearing…</p>
      </div>
    </PageCenter>
  );
}
